import { Button, Drawer, Space } from "antd";
import { AiOutlineClose } from "react-icons/ai";
import DateLine from "../../../components/shared/DateLine";
import NoResults from "../../../components/shared/NoResults";
import formatMoney from "../../../utils/formatMoney";
import formatShort from "../../../utils/formatShort";
import userimg from "../../../assets/user.png";

export default function OperatorDetails({
  isVisible,
  setShowDetails,
  selected,
  revenues,
  startDate,
  operators,
  endDate,
}: any) {
  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">Consultant Revenue :</span>
          <DateLine startDate={startDate} endDate={endDate} />
        </div>
      }
      placement={"right"}
      width={800}
      onClose={() => setShowDetails(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setShowDetails(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      {selected?.net === 0 ? (
        <NoResults />
      ) : (
        <div className="">
          <div className="flex py-1 border-b border-gray-300">
            <div className="mr-2 w-12 text-center font-bold">S/N.</div>
            <div className="flex justify-between items-center flex-1">
              <div className="flex items-center">
                <div className="font-bold">Consulant</div>
              </div>
              <div className="font-bold">Hours Sold</div>
            </div>
          </div>

          {revenues.map((consultant: any, index: number) => (
            <div className="border-t p-2 flex justify-between items-center">
              <div className="flex">
                <div className="mr-2 w-8 text-center font-bold flex justify-center items-center">
                  {index + 1}
                </div>
                <div className="h-16 w-16 flex justify-center items-center rounded-full border-4 border-gray-300">
                  <img
                    className="h-12 w-12 rounded-full"
                    src={userimg}
                    alt=""
                  />
                </div>
                <div className="flex-col ml-4">
                  <div className="font-bold text-gray-800 ">
                    {operators[consultant._id] ?? consultant._id}
                  </div>
                  <div className="text-gray-800">Service Consultant</div>
                  <div className="text-gray-500">
                    Revenue: {formatShort(consultant.net)}
                  </div>
                </div>
              </div>
              <div className="border-l w-24 pl-2 font-bold text-2xl flex justify-center items-center">
                <div className="">
                  {consultant.hours_sold.toFixed(2)}
                  <div className="text-gray-600 text-sm">Hrs</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Drawer>
  );
}
